import { ShareDataService } from '../share-data/share-data.service';
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { StorageService } from '../storage/storage.service';
import { UtilService } from '../../service/Util/Util'; // Default Environment Value

@Injectable()
export class LateModeGuardService implements CanActivate {
  static EVENT = {
    LOGIN_REQUIRED: 'LOGIN_REQUIRED',
    LOGIN_ERROR: 'LOGIN_ERROR',
    LOGIN_TOKEN_EXPIRE: 'LOGIN_TOKEN_EXPIRE',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  }
  constructor(
    public router: Router,
    public storage: StorageService,
    public util: UtilService
  ){}
  async canActivate(activatedRouteSnapshot : ActivatedRouteSnapshot) {
    let accountDetail = this.util.getEnv();

    if(accountDetail[window.location.host]?.late){
      this.router.navigate(['late']);
      return false;
    }

    return true;
  }

}
